import { connect } from 'react-redux';

import ParticipantListItem from './ParticipantListItem';
import { currentUserId } from '../../../../../core/selectors/user';
import { isInstructor } from '../../../../../core/selectors/classroom';

const mapStateToProps = (state, props) => ({
  isCurrentUser: props.userId === currentUserId(state),
  currentUserIsEducator: isInstructor(state, currentUserId(state)),
  isCreatingConversation: state.inboxv2.creatingConversationWith[props.userId],
  participantIsEducator: isInstructor(state, props.userId),
});

export default connect(mapStateToProps)(ParticipantListItem);
